import { render } from "./ColorSpectrumSelector.vue?vue&type=template&id=84b6a56e&scoped=true"
import script from "./ColorSpectrumSelector.vue?vue&type=script&lang=js"
export * from "./ColorSpectrumSelector.vue?vue&type=script&lang=js"

import "./ColorSpectrumSelector.vue?vue&type=style&index=0&id=84b6a56e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b6a56e"]])

export default __exports__